import script from "./ScreenAudioElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenAudioElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenAudioElement.vue?vue&type=style&index=0&id=adf39436&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf39436"]])

export default __exports__